import { render, staticRenderFns } from "./DuplicatedPatientIndicator.vue?vue&type=template&id=547fc370&scoped=true&"
import script from "./DuplicatedPatientIndicator.vue?vue&type=script&lang=ts&"
export * from "./DuplicatedPatientIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicatedPatientIndicator.vue?vue&type=style&index=0&id=547fc370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547fc370",
  null
  
)

export default component.exports